<template>
  <span
    ><slot></slot>
    <b-sidebar
      sidebar-class="big_sidebar create-fax-message"
      v-model="show"
      right
      :title="$t('MESSAGES.TYPE.fax-message')"
      backdrop
      no-slide
      lazy
      shadow
      no-header-close
      no-close-on-backdrop
      @shown="shownSidebar"
      no-close-on-esc
      @hidden="closeBtn"
    >
      <b-overlay :show="loading" rounded="sm">
        <div class="view-content create-message px-3 py-2">
          <div v-if="showFrom">
            <div class="info-header mt-2">{{ $t("FROM") }}</div>
            <b-form-select
              class="mt-2"
              v-model="selected_from"
              :options="from_list"
            ></b-form-select>
          </div>

          <div class="info-header mt-2">{{ $t("TO") }}</div>

          <SearchRecipients
            class="w-100 mt-2"
            :placeholder="$t('ADD_SEARCH_RECIPIENTS_FAX')"
            is-number
            single-select
            :key="'forceRedrawRecipientsKey_' + forceRedrawRecipientsIndex"
            @forceRedraw="forceRedrawRecipientsIndex++"
            message_type="fax-message"
            :user_uuid="selected_from.user_uuid"
            :functionbox_uuid="selected_from.functionbox_uuid"
            v-model="faxRecipients"
          ></SearchRecipients>

          <b-form-textarea
            class="mt-2 p-2 textarea"
            id="messageContent"
            input-id="message"
            ref="messageContent"
            v-model="content"
            autocomplete="off"
            :placeholder="$t('CONTENT')"
            rows="8"
            :state="content.length < 20000"
            max-rows="8"
          ></b-form-textarea>
          <b-form-invalid-feedback :state="content.length < 800">
            {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
          </b-form-invalid-feedback>
          <div class="text-right">
            <small class="pull-right">{{ content.length }}/500</small>
          </div>

          <form class="mt-2" v-if="files.length == 0 && attachments.length == 0">
            <FileSelect
              :max-size="GetMaxTotalBytesAllowedToSendFAXMessage"
              v-model="files"
              file-type="application/pdf"
              class="mt-2"
            >
              <b-button size="sm" variant="secondary" class="no-border">
                <i class="fal fa-plus"></i> {{ $t("ADD_FILES") }} ({{
                  files.length + attachments.length
                }})
              </b-button>
            </FileSelect>
          </form>

          <div
            class="mt-2"
            :key="'attachments_' + (attachments.length + files.length)"
          >
            <div :class="filesClass">
              <span v-if="attachments.length != 0">
                <span
                  v-for="(item, index) in attachments"
                  :key="index"
                  class="ms-fontSize-12"
                >
                  <Attachment
                    @removeFile="removeAttachment"
                    :item="item"
                    :index="index"
                  ></Attachment>
                </span>
              </span>
              <span v-if="files.length != 0">
                <span
                  v-for="(item, index) in files"
                  :key="index"
                  class="ms-fontSize-12"
                >
                  <Attachment
                    @removeFile="removeFile"
                    :item="item"
                    :index="index"
                  ></Attachment>
                </span>
              </span>
            </div>
          </div>
          <div class="error-text" v-if="!ValidateFileSize(currentFilesize)">
            {{ $t("ERROR.LARGE_FILES") }}
            {{ this.GetMaxTotalBytesAllowedToSendFAXMessage + "MB" }}
          </div>

          <hr class="p-0 m-0 mt-2 mb-2" />

          <b-button @click="closeBtn">{{ $t("CLOSE") }}</b-button>

          <b-button
            :disabled="disabledSendMessage"
            @click="sendMessage"
            variant="primary"
            class="btn-fill"
            >{{ $t("SUBMIT") }}</b-button
          >
        </div>
      </b-overlay>
    </b-sidebar>
  </span>
</template>
<script>
import * as blobUtil from "blob-util";
import SearchRecipients from "@/components/Compose/SearchRecipients";
import FileSelect from "@/components/Compose/FileSelect";
import Attachment from "@/components/Compose/Attachment";
export default {
  props: {
    reply_message_uuid: {
      default: "",
      type: String,
    },
    reply_attachments: {
      default: () => [],
      type: Array,
    },
    reply_identifier: {
      default: "",
      type: String,
    },
    reply_body: {
      default: "",
      type: String,
    },
    functionbox_uuid: {
      default: "",
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
    user_uuid: {
      default: "",
      type: String,
    },
  },
  components: {
    SearchRecipients,
    FileSelect,
    Attachment,
  },
  data() {
    return {
      addressBookSettings: null,
      forceRedrawRecipientsIndex: 0,
      attachmentIndex: 0,
      content: "",
      faxRecipients: [],
      selected_from: {
        functionbox_uuid: this.functionbox_uuid,
        user_uuid: this.user_uuid,
      },
      from_list: [],
      today: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      files: [],
      loading: false,
      attachments: [],
    };
  },
  methods: {
    shownSidebar() {
      this.getAddressBookSettings();
    },
    getAddressBookSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .post(this.user.hostname + "/settings/get", {
          setting: "AddressBook",
          organisation_uuid:
            this.user.information.organisation.organisation_uuid,
          functionbox_uuid: this.functionbox_uuid,
        })
        .then(function (result) {
          self.settings = result.data;
          self.loading = false;
          self.init();
        })
        .catch(function (error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    async init() {
      if (this.currentSignature != "") {
        this.content =
          "\n\n----------------------------\n" + this.currentSignature;
        /*setTimeout(() => {
          let input = document.getElementById("messageContent");
          input.setSelectionRange(0, 0);
        }, 500);*/
      }
      if (this.reply_identifier != "") {
        this.faxRecipients.push(this.reply_identifier);
        this.forceRedrawRecipientsIndex++;
      }
      this.attachments = this.reply_attachments.slice();
      this.attachmentIndex++;
      this.loading = true;
      this.from_list.push({
        value: {
          functionbox_uuid: "",
          user_uuid: "",
        },
        text: this.user.information.email,
      });
      if (this.reply_body != "") {
        this.content = this.reply_body;
      }
      if (this.showFrom) {
        for (let ix = 0; ix < this.user.functionboxes.items.length; ix++) {
          let item = {
            functionbox_uuid:
              this.user.functionboxes.items[ix].functionbox_uuid,
            user_uuid: "",
          };
          this.from_list.push({
            value: item,
            text:
              this.user.functionboxes.items[ix].name +
              " - " +
              this.user.functionboxes.items[ix].email +
              "",
          });
          if (
            this.functionbox_uuid ==
            this.user.functionboxes.items[ix].functionbox_uuid
          ) {
            this.selected_from = {
              functionbox_uuid:
                this.user.functionboxes.items[ix].functionbox_uuid,
              user_uuid: "",
            };
          }
        }
      }
      this.loading = false;
    },
    async closeBtn() {
      this.$emit("changeShow", false);
      //this.$emit("sentMessage");
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.attachmentIndex++;
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
      this.attachmentIndex++;
    },
    async getFileContent(file) {
      return new Promise((resolve) => {
        blobUtil
          .blobToBase64String(file)
          .then(function (base64String) {
            resolve(base64String);
          })
          .catch(function () {
            resolve(null);
          });
      });
    },
    async sendMessage() {
      let self = this;
      this.loading = true;
      if (this.files.length != 0) {
        this.attachments = [];
        for (let ix = 0; ix < this.files.length; ix++) {
          let base64Content = await this.getFileContent(this.files[ix]);
          if (base64Content == null) {
            //this.$noty.error(self.$t("ERROR.EXCEPTION"));
            return false;
          } else {
            this.attachments.push({
              name: this.files[ix].name,
              type: this.files[ix].type,
              content: base64Content,
            });
          }
        }
        this.files = [];
      }
      this.attachmentIndex++;
      let to_number = this.faxRecipients[0];
      this.$http
        .post(this.user.hostname + "/fax/secure", {
          functionbox_uuid: this.selected_from.functionbox_uuid,
          body: this.content,
          to_number: to_number,
          attachments: this.attachments,
          response_to_message_uuid: this.reply_message_uuid,
        })
        .then(function () {
          self.$emit("changeShow", false);
          self.$emit("sentMessage");
          self.loading = false;
          self.$noty.info(self.$t("SENT_FAX_MESSAGE"));
        })
        .catch(function (error) {
          console.log(error);
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    ValidateFileSize(bytes) {
      return bytes < this.GetMaxTotalBytesAllowedToSendFAXMessage * 1024 * 1024;
    },
  },
  computed: {
    currentFilesize() {
      let filesize = 0;
      for (let ix = 0; ix < this.attachments.length; ix++) {
        filesize += this.attachments[ix].size;
      }
      for (let ix = 0; ix < this.files.length; ix++) {
        filesize += this.files[ix].size;
      }
      return filesize;
    },
    currentSignature() {
      let self = this;
      let currentSignature = this.user.information.signature;
      if (this.functionbox_uuid != "") {
        let me = this.user.functionboxes.items.filter(
          (c) => c.functionbox_uuid == self.functionbox_uuid
        );
        if (me.length != 0) {
          currentSignature = me[0].signature;
        }
      } else {
        if (this.user_uuid != "") {
          let me = this.user.delegatedboxes.items.filter(
            (c) => c.user_uuid == self.user_uuid
          );
          if (me.length != 0) {
            currentSignature = me[0].signature;
          }
        }
      }
      return currentSignature;
    },
    showFrom: function () {
      return (
        (this.user.functionboxes.items.length != 0 ||
          this.user.delegatedboxes.items.length != 0) &&
        this.reply_subject == ""
      );
    },
    disabledSendMessage: function () {
      if((this.attachments.length + this.files.length) > 1)
      {
        return true;
      }
      if (!this.ValidateFileSize(this.currentFilesize)) {
        return true;
      }
      if (this.faxRecipients.length == 0) {
        return true;
      }
      if (this.files.length == 0) {
        if (this.content.length == 0) {
          return true;
        }
      }
      if (this.content.length > 500) {
        return true;
      }
      return false;
    },
    filesClass() {
      if (this.ValidateFileSize(this.currentFilesize)) {
        return ["is-valid"];
      } else {
        return ["is-invalid"];
      }
    },
  },
  mounted() {},
};
</script>